import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import abTestReducer from './slices/abTestSlice';
import { apiSlice } from './api/apiSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    abTest: abTestReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
